import React from 'react';
import { useSupabaseImage } from '../../utils/imageUtils';
import ballIcon from '../../assets/messages/ball.png'; // Reuse existing ball icon as fallback

const FRONTEND_FALLBACK_AVATAR_ASSET = ballIcon; // Use ball icon as ultimate fallback
const BACKEND_DEFAULT_AVATAR_PATH = FRONTEND_FALLBACK_AVATAR_ASSET;

const UserAvatar = ({ 
  avatarUrl, 
  userName, 
  className = "",
  size = "default", // small, default, large
  style = {}
}) => {
  const { currentSrc, isLoading, handleError } = useSupabaseImage(
    avatarUrl,
    userName ? `${userName} avatar` : 'user avatar',
    FRONTEND_FALLBACK_AVATAR_ASSET,
    BACKEND_DEFAULT_AVATAR_PATH
  );

  // Show loading state for Supabase images
  if (isLoading) {
    return (
      <img 
        src={FRONTEND_FALLBACK_AVATAR_ASSET} 
        alt={userName ? `Loading ${userName}'s avatar...` : 'Loading avatar...'} 
        className={`user-avatar ${size} ${className} loading-opacity`}
        style={{ ...style, opacity: 0.5 }}
      />
    );
  }

  return (
    <img 
      src={currentSrc} 
      alt={userName ? `${userName}'s avatar` : 'User avatar'} 
      className={`user-avatar ${size} ${className}`}
      style={style}
      onError={handleError}
    />
  );
};

export default UserAvatar;
